export interface IGlobalContext {
	PageName: INamePageContext,
	PageWelcome: IWellcomePageContext
}

export interface IPageContext {
	name: string;
	context: INamePageContext | IWellcomePageContext; // agregar pages a medida que se creen nuevas
}

export interface INamePageContext {
	name?: string;
}

export interface IWellcomePageContext {
	evaluationProfile?: eEvaluationProfile;
}

export enum eEvaluationProfile {
	invest,
	refinancing
}

export enum ePageNames {
	namePage = 'namePage',
	wellcomePage = 'wellcomePage'
}

// eslint-disable-next-line no-unused-vars 
export enum STATUS {
	// eslint-disable-next-line no-unused-vars
	idle,
	// eslint-disable-next-line no-unused-vars
	pending,
	// eslint-disable-next-line no-unused-vars
	error,
	// eslint-disable-next-line no-unused-vars
	init
}

export enum ePropertyCondition {
	new = 1,
	used = 2
}

export enum eOperationFamily {
	ventaUsado = 1,
	ventaNuevo = 2,
	arriendo = 3,
}
export enum eLeadType {
	quote = 1,
	contact = 2
}
export enum eOriginId {
	listaSeoQuote = 39,
	listaSeoContact = 40,
	listaSeoItau= 42,
}
